import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { tracking } from '../utils/tracking';

export const usePageView = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      tracking.pageView(url);
    };

    const unsubscribe = router.history.subscribe(({ location }) => {
      handleRouteChange(location.href);
    });

    return () => {
      unsubscribe();
    };
  }, [router]);
};
